import React, { useCallback, useRef, useImperativeHandle } from 'react';
import { useGlobal } from '../../../hooks/global';
import { ContainerField, FieldError } from '../../../style';
import { BaseInput } from '../../../pages/WebCheckinUser/components/Inputs/Input/style';
import Form from "react-bootstrap/Form";
import { MaskTypes } from '../../../interfaces';
import { Masks } from '../Input/mask';

export interface InputRefProps {
  getValue: () => string;
  setValue: (newValue: string) => void;
  focus: () => void;
}

interface InputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  mask?: MaskTypes;
  noUpperCase?: boolean;
  isPassword?: boolean;
  error?: any;
  options?: any;
  label?: string;
}

const InputPhoneAdm: React.ForwardRefRenderFunction<InputRefProps, InputProps> = (
  props,
  ref
) => {
  const {
    mask,
    error,
    options = { onChange: () => { } },
    style = {},
    isPassword = false,
    noUpperCase = false,
    onKeyDown = () => { },
    onChange = () => { },
    label = "Label",
    ...rest
  } = props;

  const { theme } = useGlobal();

  const inputRef = useRef<HTMLInputElement>(null);

  const handleKeyUp = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      if (mask && Masks?.[mask as string]) Masks[mask](e);
    },
    [mask]
  );

  const getValue = useCallback(() => {
    if (mask === "m2") {
      let value_input: any = inputRef.current?.value
        ? inputRef.current?.value
        : "";
      value_input = value_input.replace(/\D/g, "");
      if (value_input !== "") value_input = Number.parseInt(value_input) / 100;
      return value_input;
    } else return inputRef.current?.value ? inputRef.current?.value : "";
  }, [mask]);

  const focus = useCallback(() => {
    inputRef.current?.focus();
  }, []);

  const setValue = useCallback(
    (newValue: string) => {
      if (inputRef && inputRef.current) inputRef.current.value = newValue;
    },
    []
  );

  const handleKeyDown = useCallback(
    (e: any) => {
      if (
        mask === "m2" &&
        (e.nativeEvent.key === "Delete" ||
          e.nativeEvent.key === "Backspace" ||
          (e.charCode >= 48 && e.charCode <= 57))
      ) {
        let value = e.currentTarget.value;
        value = value.replace(" m²", "");
        e.currentTarget.value = value;
      }
      if (
        mask === "porcen" &&
        (e.nativeEvent.key === "Delete" ||
          e.nativeEvent.key === "Backspace" ||
          (e.charCode >= 48 && e.charCode <= 57))
      ) {
        let value = e.currentTarget.value;
        value = value.replace(" %", "");
        e.currentTarget.value = value;
      }
      onKeyDown(e);
      return e;
    },
    [mask]
  );

  const handleOnChange = useCallback(
    (e: any) => {
      onChange(e?.target?.value);
      if (options?.onChange) {
        options.onChange(e);
      }
    },
    [onChange, options]
  );

  useImperativeHandle(ref, () => ({
    getValue,
    setValue,
    focus
  }), [getValue, setValue, focus]);

  return (
    <ContainerField style={{ marginTop: 1, flex: 1, width: '100%', }}>
      <Form.Control
        onKeyDown={handleKeyDown}
        style={{
          ...style,
          textTransform: noUpperCase ? "none" : "uppercase",
        }}
        ref={inputRef}
        autoComplete="nope"
        onKeyUp={handleKeyUp}
        type="text"
        {...rest}
        {...options}
        onChange={handleOnChange}
      />

      {error && !props?.disabled && (
        <FieldError title={error}>{error}</FieldError>
      )}
    </ContainerField>
  );
};

export default React.forwardRef(InputPhoneAdm);
